module.exports = __webpack_public_path__ + "img/Lesotho.5bf3548c.svg";